import React from "react";
import techSalesMarketing from "../../assets/images/technology/tech-sales-marketing.png";

const Intro = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-white" id="technology-intro">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          
          {/* Text Column */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-3xl sm:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              The Future of Technology in Sales and Marketing Automation
            </h2>
            <p className="tw-text-base sm:tw-text-lg tw-text-slate-600 tw-leading-relaxed tw-mb-6">
              At our core, we believe technology is the key to unlocking limitless potential. By combining cutting-edge tools with intuitive designs, we aim to simplify complex processes and empower businesses to focus on innovation and growth.
            </p>
            <p className="tw-text-base sm:tw-text-lg tw-text-slate-600 tw-leading-relaxed tw-m-0">
              From AI to IoT, we’re not just following the technology revolution—we’re leading it. Our mission is to help businesses harness the latest innovations to stay competitive, adaptive, and successful in an ever-changing market.
            </p>
          </div>

          {/* Image Column */}
          <div className="lg:tw-col-span-5 tw-text-center">
            <img
              src={techSalesMarketing}
              alt="Technology in Sales and Marketing"
              className="tw-w-full tw-h-auto tw-max-h-[380px] tw-object-contain hover:tw-scale-[1.01] tw-transition-transform tw-duration-300"
              loading="lazy"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default Intro;
